import { Xmark } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import { BUDDY_TOUR_TOTAL_STEPS } from 'config/buddy/tour';

const TOUR_DEFAULTS = {
  BUDDY_TOUR_OKAY: 'Got it',
  BUDDY_TOUR_CLOSE: 'Close',
  BUDDY_TOUR_CONVERSATION_TITLE: 'Chat with Buddy',
  BUDDY_TOUR_GROUP_TITLE: 'Agents',
  BUDDY_TOUR_STEP1_BODY:
    'This is where I live. Start new chats here and find all your earlier ones.',
  BUDDY_TOUR_STEP2_BODY: 'Switch between agents and projects here.',
  BUDDY_TOUR_QUICK_ACTIONS_TITLE: 'Quick actions',
  BUDDY_TOUR_STEP3_BODY: 'This is where you set up skills and routines and add plugins.',
  BUDDY_TOUR_MESSAGE_TITLE: 'Message Buddy',
  BUDDY_TOUR_STEP4_BODY: 'Write to me here: a question, a request or a whole task.',
};

/** `context` is `informal` for du; the bodies address the user, the rest has one form. */
export default function BuddyTourCard({ copy, context, onClose, onOkay }) {
  const { t } = useTranslation();
  const title = t(copy.titleKey, { defaultValue: TOUR_DEFAULTS[copy.titleKey] });
  const body = t(copy.bodyKey, { defaultValue: TOUR_DEFAULTS[copy.bodyKey], context });
  const okay = t(copy.okayKey, { defaultValue: TOUR_DEFAULTS.BUDDY_TOUR_OKAY });
  const close = t(copy.closeKey, { defaultValue: TOUR_DEFAULTS.BUDDY_TOUR_CLOSE });
  const step = t('BUDDY_TOUR_STEP', {
    defaultValue: '{{step}}/{{total}}',
    step: copy.step,
    total: BUDDY_TOUR_TOTAL_STEPS,
  })
    .replaceAll('{{step}}', String(copy.step))
    .replaceAll('{{total}}', String(BUDDY_TOUR_TOTAL_STEPS));

  return (
    <div className="klax-buddy__tour">
      <button type="button" className="klax-buddy__tour-close" aria-label={close} onClick={onClose}>
        <Xmark width={16} height={16} strokeWidth={1.5} />
      </button>
      <p className="klax-buddy__tour-title">{title}</p>
      <p className="klax-buddy__tour-body">{body}</p>
      <div className="klax-buddy__tour-foot">
        <p className="klax-buddy__tour-step">{step}</p>
        <button type="button" className="klax-buddy__tour-okay" onClick={onOkay}>
          {okay}
        </button>
      </div>
    </div>
  );
}
